/* eslint-disable */

/** unique or primary key constraints on table "argo.connection_config_status" */
export enum ArgoConnectionConfigStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  ArgoConnectionConfigStatusPkey = 'argo_connection_config_status_pkey'
}

export enum ArgoConnectionConfigStatusEnum {
  Released = 'released',
  Retired = 'retired',
  Staged = 'staged'
}

/** select columns of table "argo.connection_config_status" */
export enum ArgoConnectionConfigStatusSelectColumn {
  /** column name */
  Status = 'status'
}

/** update columns of table "argo.connection_config_status" */
export enum ArgoConnectionConfigStatusUpdateColumn {
  /** column name */
  Status = 'status'
}

